import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { Input, TimePicker } from 'antd';
import _ from 'lodash';
import CheckableTag from 'antd/lib/tag/CheckableTag';
import { getConfigFromCronString, getCronStringFromConfig } from 'views/RunBook/utils/formatter';
import { Days, daysValues, defaultTime } from './ACAdvancedCron';

const getTimeandDays = (cron, type) => {
    const data = getConfigFromCronString(cron)
    return type === "time" ? data.time : data.daysOfTheWeek
}

const CronConfig = ({ onChange = _.noop, value: cron }) => {
    const [selectedTime, setSelectedTime] = useState(() => cron ? getTimeandDays(cron, "time") : defaultTime)
    const [selectedDays, setSelectedDays] = useState(() => cron ? getTimeandDays(cron, "days") : daysValues)

    const cronString = useMemo(() => (
        getCronStringFromConfig({
            time: selectedTime,
            daysOfTheWeek: selectedDays
        })
    ),[selectedTime, selectedDays])

    // We just want to run useEffect on componentDidMount
    useEffect(() => {
        cronString && onChange(cronString)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getCronString = useCallback((time, daysOfTheWeek) => {
        const cronString =  getCronStringFromConfig({
            time,
            daysOfTheWeek
        });
        onChange(cronString);
    }, [onChange])


    const handleDaySelection = useCallback((day, checked) => {
        const daySelection = [...selectedDays];
        if(checked === true){
            daySelection.push(day);
        }else{
            const spliceIndex = daySelection.indexOf(day);
            daySelection.splice(spliceIndex,1);
        }
        setSelectedDays(daySelection)
        getCronString(selectedTime, daySelection)
    },[getCronString, selectedDays, selectedTime]);

    const handleTimeSelection = useCallback((time) => {
        setSelectedTime(time)
        getCronString(time, selectedDays)
    }, [getCronString, selectedDays])

    const DaysCheckableTags = Days.map(({label, value}) => (
    <CheckableTag
        key={`${label}_${value}`}
        checked={selectedDays.indexOf(value) > -1}
        onChange={checked => handleDaySelection(value, checked)}
        className='runbook-checkable-tags'
      >
        {label}
      </CheckableTag>
    ));

  return (
    <Input.Group>
        {DaysCheckableTags}
        <TimePicker popupClassName="custom-time-picker" value={selectedTime} use12Hours showNow={false} format="h:mm a" onSelect={handleTimeSelection}/>
    </Input.Group>
  );
};

export default CronConfig;